export default "__VITE_ASSET__oMSvmDXi__";